export const string_between_strings = (startStr: string, endStr: string, str: string) => {
	const pos = str.indexOf(startStr);
	return str.substring(pos, str.indexOf(endStr, pos) + endStr.length);
};
